import { render, staticRenderFns } from "./editPayrollUserSalary.vue?vue&type=template&id=60339c68&"
import script from "./editPayrollUserSalary.vue?vue&type=script&lang=js&"
export * from "./editPayrollUserSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports